import { useTranslation } from 'next-i18next';
import { ElementType, Fragment } from 'react';

export interface TranslateComponentProps {
  /** Wrap the translation with a specific element */
  wrapperComponent?: ElementType;
  id: string;
  namespace?: string;
}

const Translate: React.FC<TranslateComponentProps> = ({
  id,
  wrapperComponent,
  namespace,
}) => {
  const { t } = useTranslation([
    'common',
    'login',
    'codes',
    'payment',
    'onboarding',
  ]);
  const message = t(id, { ns: namespace });
  const Wrapper = wrapperComponent;
  if (Wrapper) {
    return <Wrapper>{message}</Wrapper>;
  }

  return <Fragment>{message}</Fragment>;
};

export default Translate;
